"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContentsQuery = useContentsQuery;
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _swr = _interopRequireDefault(require("swr"));
var _contexts = require("../contexts");
var _utils = require("../utils");
var RegistrationSufixUrlType = /*#__PURE__*/function (RegistrationSufixUrlType) {
  RegistrationSufixUrlType["VipCustomer"] = "vipCustomerContent";
  RegistrationSufixUrlType["Consultant"] = "brandPartnerContent";
  return RegistrationSufixUrlType;
}(RegistrationSufixUrlType || {});
async function fetchContents(url, tenant, currentLanguage) {
  const locale = getLocale(currentLanguage);
  const response = await (0, _utils.fetcher)(url, {
    token: '',
    headers: {
      'Accept-Language': locale
    },
    tenant
  });
  const {
    Contents: contents,
    DefaultLanguage: defaultLanguage
  } = response;
  const currentLocale = locale.length > 0 ? locale : defaultLanguage;
  return {
    locale: currentLocale || '',
    contents: contents[currentLocale]
  };
}
function getLocale(currentLanguage) {
  if (currentLanguage) {
    return currentLanguage;
  }
  if (document.documentElement.lang) {
    return document.documentElement.lang;
  }
  return navigator.language;
}
function useContentsQuery() {
  const {
    currentLanguage,
    registrationType
  } = (0, _contexts.useConfiguration)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const registrationTypeSufix = registrationType === 'VipCustomer' ? RegistrationSufixUrlType.VipCustomer : RegistrationSufixUrlType.Consultant;
  const response = (0, _swr.default)(`${staticApiUrl}/tenants/${tenant}/applications/simplifiedRegistration/${registrationTypeSufix}`, async url => fetchContents(url, tenant, currentLanguage));
  return response;
}